/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * The kind of stream item the user is creating or editing.

https://shorturl.at/piYHg
 * @export
 * @enum {string}
 */
export type ClassroomItemType =
  'courseWork' | 
  'courseWorkMaterials' | 
  'announcement'




export function ClassroomItemTypeFromJSON(json: any): ClassroomItemType {
    return ClassroomItemTypeFromJSONTyped(json, false);
}

export function ClassroomItemTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassroomItemType {
    return json;
}

export function ClassroomItemTypeToJSON(value?: ClassroomItemType | null): any {
    return value;
}

